import React from 'react';

export default function Learn() {
  return (
    <div id="learn">
      <div className="pt-6 pb-24 bg-gray-200 lg:text-center lg:pt-12">
        <div className="container px-10 mx-auto">
          <div className="relative">
            <h2 className="mb-24 text-4xl font-bold text-center text-purple-900 lg:mb-32 md:text-5xl lg:text-6xl">
              What youll learn in this course
            </h2>
            <div className="absolute top-0 left-0 w-5/12 h-2 transform -translate-y-8 rounded bg-gradient-to-r from-purple-700 to-blue-200"></div>
            <div className="absolute bottom-0 right-0 w-5/12 h-2 transform translate-y-8 rounded bg-gradient-to-l from-purple-700 to-blue-200"></div>
          </div>

          <div className="grid-cols-6 gap-8 space-y-4 lg:space-y-0 lg:grid">
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>

              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-3 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-3 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>

              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
            <div className="col-span-2 border border-gray-700 rounded shadow-lg">
              <div className="flex items-center justify-between p-4 border-b border-gray-700">
                <h3 className="text-lg font-semibold ">
                  How to use tailwind classes
                </h3>
                <div className="flex space-x-1">
                  <div className="w-3 h-3 bg-green-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-yellow-500 rounded-lg"></div>
                  <div className="w-3 h-3 bg-red-500 rounded-lg"></div>
                </div>
              </div>
              <p className="p-4">
                We'll dive into the most important Tailwind classes and use them
                a TON.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
